<template>
  <!-- 审批时的申请明细，表格内容可编辑，其他纯展示 -->
  <div class="apply-edit-detail">
    <a-card title="申请明细" :loading="!creditInfo" class="card">
      <credit-info-view
        ref="creditInfoView"
        :type="type"
        :credit-info="creditInfo"
        :risk-evaluation="riskEvaluation"
        :has-risk-modal="hasRiskModal"
        :can-edit-risk-type="canEditRiskType"
        @getModalFromChild="getModalFromChild"
        @getSegmentFromChild="getSegmentFromChild"
        @getLinkFromChild="getLinkFromChild"
        @getRiskTypeFromChild="getRiskTypeFromChild"
      />

      <!-- 信用类型申请表格 -->
      <div class="apply-tables">
        <!-- 信用限额table -->
        <credit-limit-table
          ref="creditLimitTable"
          :type="type"
          :data-source="limitAmountList"
          :base-info="baseInfo"
          :limitAmount="limitAmount"
        ></credit-limit-table>

        <!-- 正常额度table | 临时额度table-->
        <loan-table
          ref="loanTable"
          :type="type"
          :data-source="loanAmountList"
          :base-info="baseInfo"
        ></loan-table>

        <!-- 专项额度table -->
        <special-table
          ref="specialTable"
          :type="type"
          :data-source="specialAmount"
          :base-info="baseInfo"
          :hide-action-column="true"
        ></special-table>
      </div>

      <!-- 申请原因及备注 -->
      <apply-reason-remark
        :content="(creditInfo && creditInfo.remark) || ''"
        :attachments="attachments"
      />
    </a-card>
  </div>
</template>

<script>
import Vue from 'vue'
import CreditInfoView from './CreditInfoView.vue'
import CreditLimitTable from './CreditLimitEditTable.vue'
import LoanTable from './LoanEditTable.vue'
import SpecialTable from './SpecialEditTable.vue'
import ApplyReasonRemark from './ApplyReasonRemarkView.vue'
import { CREDIT_TYPE_VALUE_OBJ } from '../../const'

export default {
  name: 'ApplyViewEditDetail',
  data() {
    return {
      title: '申请明细',
      gutter: { xs: 8, sm: 16, md: 24, lg: 24 },
    }
  },
  props: [
    'creditInfo',
    'type',
    'limitAmount',
    'loanAmount',
    'specialAmount',
    'baseInfo',
    'attachments',
    'riskEvaluation',
    'hasRiskModal',
    'canEditRiskType',
  ],
  computed: {
    limitAmountList() {
      return [{ key: 1, ...this.limitAmount }]
    },
    loanAmountList() {
      return [{ key: 1, ...this.loanAmount }]
    },
  },
  methods: {
    validate() {
      const checkCreditInfoView = this.$refs.creditInfoView.validate()
      if (checkCreditInfoView) {
        const checkTables = this.validateTables()
        if (checkTables) {
          return { ...checkTables, ...checkCreditInfoView }
        }
      }
      return false
    },

    // 校验表格里的数据，若校验不通过则返回 false，若通过则返回 Tables 的数据
    validateTables() {
      let checkCreditLimitTable
      let checkLoanTable
      let checkSpecialTable
      if (
        (checkCreditLimitTable = this.$refs.creditLimitTable.validate()) &&
        (checkLoanTable = this.$refs.loanTable.validate()) &&
        (checkSpecialTable = this.$refs.specialTable.validate())
      ) {
        return {
          limitAmount: checkCreditLimitTable,
          loanAmount: checkLoanTable,
          specialAmount: checkSpecialTable,
        }
      }
      console.log('表格未通过校验')
      return false
    },

    // 校验type!=1时，增加判断“申请后总额度”vs有效期内限额条件中的“控货金额”合计数
    validateTotalAmount(confirmSkipStatus) {
      return new Promise(resolve => {
        const limitControlAmount = this.baseInfo.limitControlAmount //控货金额
        let totalWithRoadAmount =
          this.$refs.loanTable.getTotalWithRoadAmount() ||
          this.$refs.specialTable.getTotalWithRoadAmount() //申请后总额度
        if (
          this.type != CREDIT_TYPE_VALUE_OBJ.CREDIT_TYPE &&
          limitControlAmount &&
          totalWithRoadAmount > limitControlAmount &&
          !confirmSkipStatus
        ) {
          this.$confirm({
            title: '提示',
            content: `超过${Vue.filter('formatAmount')(
              limitControlAmount,
            )}需要控货，请做好控货操作, 是否继续?`,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
              resolve()
            },
            onCancel: () => {
              this.$message.info('已取消提交')
            },
          })
        } else {
          resolve()
        }
      })
    },
    getModalFromChild(query) {
      this.$emit('getModalFromCC', query)
    },
    getSegmentFromChild(query) {
      this.$emit('getSegmentFromCC', query)
    },
    getLinkFromChild(query) {
      this.$emit('getLinkFromCC', query)
    },
    getRiskTypeFromChild(value) {
      this.$emit('getRiskTypeFromChild', value)
    },
  },
  components: {
    CreditInfoView,
    CreditLimitTable,
    LoanTable,
    SpecialTable,
    ApplyReasonRemark,
  },
}
</script>

<style lang="less" scoped>
.apply-tables {
  .ant-table-wrapper {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.apply-reason-memo {
  margin: 20px 0;
}
</style>
